import { Injectable } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override getDayOfWeekNames(_style: 'long' | 'short' | 'narrow'): string[] {
    const shortNames = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
    return shortNames;
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }
}
